// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PdgX","top":"styles_top__3H1kO","left":"styles_left__2pE-E","description":"styles_description__3q9Nf"};